import { MenuItem, TextField } from '@mui/material'
import { useFieldContext } from '@zealth/core/form/contexts'
import type { DropdownFormFieldProps } from '@zealth/core/formFields/types'

export { type DropdownFormFieldProps }

export const DropdownFormField = <T extends string | number | null = string>({
  options,
  label,
  optional,
  serialize = (val: T) => val?.toString() ?? '',
  deserialize = (raw: string) => raw as T,
}: DropdownFormFieldProps<T> & {
  serialize?: (val: T) => string
  deserialize?: (raw: string) => T
}) => {
  const field = useFieldContext<T>()

  return (
    <TextField
      select
      fullWidth
      required={!optional}
      label={label}
      value={serialize(field.state.value)}
      error={field.state.meta.errors.length > 0}
      helperText={field.state.meta.errors[0]?.message ?? ' '}
      onChange={e => field.handleChange(deserialize(e.target.value))}
    >
      {optional && (
        <MenuItem value="">
          <em>Not specified</em>
        </MenuItem>
      )}
      {options.map(({ value, label }) => (
        <MenuItem key={serialize(value)} value={serialize(value)}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  )
}
